import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  ButtonGroup,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Card,
  Alert,
  OverlayTrigger,
  Tooltip,
  Dropdown,
} from "react-bootstrap";

import * as Yup from "yup";
import moment from "moment";
import { Link } from "react-router-dom";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

//Tabla, Navbar y Sidebar
import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import SidebarCarreraSucesion from "../../../components/Carrera_Sucesion/SidebarCarreraSucesion";

//Redux
import {
  getCourseFun,
  getCourse,
  getTasks,
  editCourseFun,
  saveCourseFun,
  deleteCourseFun,
  searchCourseFun,

} from "../../../redux/Carrera_Sucesion/CursosFunciones/actions";
import messages from "../../../redux/messages";
const CoursesFuncion = (props) => {
  const filters = [
    { id: "nombre_curso", desc: "Nombre del Curso" },
    { id: "curso__codigo", desc: "Código del Curso" },
    { id: "funcion_descripcion", desc: "Nombre de la función" },
    { id: "funcion_codigo", desc: "Código de función" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [editCurso, setEditCurso] = useState({});
  const [editFuncion, setEditFuncion] = useState({});

  const [cursoSelected, setCursoSelected]=useState([]);
  const [_curso, setCurso] = useState(false);
  //
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [funSelected, setFunSelected] = useState([]);
  const [_funcion, setFuncion] = useState(false);
  //
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre_curso",   
    desc: "Nombre del Curso",
  });
  const dispatch = useDispatch();

  //Validacion del form
  const schema = Yup.object().shape({
    funcion: Yup.string().required("**Campo requerido"),
    curso: Yup.string().required("**Campo requerido"),   
    
  });
  
  const {
    loading,
    loadingById,
    saveLoading,
    coursesFuncionLength,
    coursesFuncion,
    courseFuncion,
    courseFuncionError,
    coursesLength,
    courses,
    coursesError,
    task,
    tasks,
    formError,
  } = useSelector((store) => store.cursosFuncion); 
  const pages = Math.ceil(coursesFuncionLength / limit);


  //Cursos
  let cursosOptions = [];
  courses &&
    // eslint-disable-next-line array-callback-return
    courses.map((course) => {
      cursosOptions = [
        ...cursosOptions,
        {
          id: course.id,
          label: course.nombre
            ? `${course.codigo} / ${course.nombre.toUpperCase()}`
            : "",
          curso_id: course.id,
    
          item: course,
        },
      ];
    });

    let funcionOptions = [];
    tasks &&
      // eslint-disable-next-line array-callback-return
      tasks.map((task) => {
        funcionOptions = [
          ...funcionOptions,
          {
            id: task.id,
            label: task.descripcion
              ? `${task.codigo} / ${task.descripcion.toUpperCase()}`
              : "",            
            item: task,
          },
        ];
      });
 
  //Datos para el custom table
  const columns = [    
    {
      Header: "Curso",
      accessor: "nombre_curso",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_curso &&
          value.row.original.list_curso[0]
            ? value.row.original.list_curso[0].codigo + " | "+ value.row.original.list_curso[0].nombre
            : "No ingresado"}
        </div>
      )
    },
    {
      Header: "Función",
      accessor: "funcion_descripcion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.list_funcion &&
          value.row.original.list_funcion[0]
            ? value.row.original.list_funcion[0].codigo + " | "+ value.row.original.list_funcion[0].descripcion
            : "No ingresado"}
        </div>
      ),
    },    
    {
      Header: "Fecha de creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(
              value.row.original,
              value.row.original.list_curso &&
              value.row.original.list_curso,
              value.row.original.list_funcion &&
              value.row.original.list_funcion, value.row.index          
            )}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Metodos para acceder a las funciones


  // Metodos de cursos funcion 
  const getACourseFuncion = (off = offset, lim = limit, filt = filter) =>
    dispatch(
      getCourseFun({
        offset: off,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );
  
    
    const getACourse = () =>
      dispatch(
        getCourse(

        )
      );
  
      const getAFuncion = () =>
        dispatch(
          getTasks()
        );


  useEffect(() => {
    getACourse();
    getAFuncion();
    getACourseFuncion();    
  }, []);
  

  const addCourseFun = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item,curso, funcion, index) => {
    
    setIndex(index);
    setEdit(true);
    setEditCurso(curso);
    setEditFuncion(funcion);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  
  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(0);
    setCurrentPage(1);
    getACourseFuncion(oOffset, limit, e.target.filter.value);
  };


  const onSubmit = async (req) => {

    const _req = {
      ...req,

      curso: req.curso,
      funcion: req.funcion,
      fecha_creacion: moment(new Date()).format("YYYY-MM-DD"),
    };
    if (!edit) {
      dispatch(saveCourseFun(_req, setShowModal));
    } else {
      dispatch(editCourseFun(_req, editItem.id, index, setShowModal));
    }
  };



  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getACourseFuncion(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {

    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteCourseFun(id, index));
      window.alert("Se borró este curso");
    }
  };




  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCarreraSucesion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
      <Container fluid>
      <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6>Cursos Función</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      onClick={() => addCourseFun()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Row>
              
            </Form>
          </div>     
      {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            coursesFuncionLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={coursesFuncion} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={coursesFuncionLength}
                  pages={pages}
                  pagFunc={getACourseFuncion}
        
                />
              </>
            )
          )}
          {!loading && coursesFuncionLength === 0 && coursesFuncion === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
          {!!courseFuncionError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {courseFuncionError}
            </Alert>
          )}
        </Container>
      </div>

      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        >
         <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            id: edit ? editItem.id : "",
            funcion: edit ? editFuncion[0].id : "",
            curso: edit ? editCurso[0].id: "",          
          
          }}
            
        >
          
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            errors,
          }) => (
            
            
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar curso función" : "Crear curso función"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className={"mt-4 mb-1 mx-3"}>
                    {formError}
                  </Alert>
                )}
                
                <Form.Group className="mb-3">
                  <Form.Label column sm="12" md="12">
                    Curso:
                  </Form.Label>    
                  <Row className="d-flex flex-wrap align-items-center">
                        <Col sm={11} xs={11}>
                          <Typeahead
                            id="curso"
                            name="curso"                            
                            isInvalid={touched.course && errors.course}
                            isValid={touched.course&& !errors.course}
                            onBlur={handleBlur("Curso")}
                            placeholder="Seleccione un curso"
                            options={cursosOptions}                          
                            value={values.curso}
                            onChange={(selected) => {
                              setFieldValue(
                                "curso",
                                selected.length > 0 ? selected[0].id : "",
                
                              );
                              setCursoSelected(selected);                             
                              setCurso(selected.length > 0);
                             
                     
                            }}
                            defaultInputValue={edit ? `${editCurso[0].codigo} / ${editCurso[0].nombre}`
                              : ""}

                          >
                            
                          </Typeahead>
                        </Col>
                      </Row>
                  <Form.Label column sm="12" md="12">
                    Función:
                  </Form.Label>
                  <Row className="d-flex flex-wrap align-items-center">
                        <Col sm={11} xs={11}>
                          <Typeahead
                            id="funcion"
                            name="funcion"
                            isInvalid={touched.task && errors.task}
                            isValid={touched.task && !errors.task}
                            onBlur={handleBlur("Funcion")}
                            placeholder="Seleccione un función"
                            options={funcionOptions}
                            value={values.funcion}
                            onChange={(selected) => {
                              setFieldValue(
                                "funcion",
                                selected.length > 0 ? selected[0].id : ""
                              );
                              setFunSelected(selected);
                              setFuncion(selected.length > 0);

                            }}
                            defaultInputValue={edit ? `${editFuncion[0].codigo} / ${editFuncion[0].descripcion}`
                              : ""}

                              

                          ></Typeahead>
                        </Col>
                      </Row>                 
                    
                
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  disabled={saveLoading}
                  type="submit"
                  

                >
                  {" "}
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    
                  )}
                  Guardar
                  
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>

        </Modal>

    </>
  );
};

export default CoursesFuncion;
